import { CancelAsync } from './../../app/models/cancelAsync';

import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';

import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';

import {
  AppInitService,
  CPFSubscriptionsService,
  NavigationService,
  PageLoaderService,
  StatsService,
  StudentService,
} from '@app/services';

import { Student } from '@app/models';

import { UtilsService } from '@commons/services';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';

@EasyDebugDecorator
@Component({
  selector: 'eligibilite-cpf-page',
  templateUrl: 'eligibilite-cpf.page.html',
  styleUrls: ['eligibilite-cpf.page.scss'],
})
export class EligibiliteCPFPage extends CancelAsync {
  pageTitle =
    'Eligibilite CPF'; /* NE SERT A RIEN MAIS OBLIGATOIRE (RELIQUAT D'UN CODE NON NETTOYER #flemme) */
  activeLink =
    'code'; /* PERMET DE METTRE EN SURBRILLANCE LA CATÉGORIE DE NAV EN QUESTION LIÉE A CETTE PAGE */

  initPageDone = false;

  isDesktop = window.innerWidth > 767 ? true : false;
  isCordova = false;

  blocHeaderTitle = "Retour vers l'appplication";
  blocHeaderBackUrl = 'profil';

  student: Student;
  userLifeCycle: any;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  secureId = null;
  activeStep = 1;
  eligibiliteCPFSteps = [
    {
      step: 1,
      text: 'Mon éligibilité',
      icon: 'paper-plus-off',
      mobileWidth: 140, // needed to fix slider issue
    },
    {
      step: 2,
      text: 'Ma signature',
      icon: 'edit-off',
      mobileWidth: 130, // needed to fix slider issue
    },
    {
      step: 3,
      text: 'Mon récapitulatif',
      icon: 'question-square-off',
      mobileWidth: 155, // needed to fix slider issue
    },
  ];
  eligibiliteCPFCurrentStep: any = {};
  eligibiliteCPFPreviousStepStatus = null;
  displayErrorSecureId = false;
  displayErrorRetry = false;
  displayErrorEmpty = false;
  recapSubStep = null;
  checkTypeformDivReady: any;
  yousignSignatureLink = null;
  submitting = false;
  retry = 0;
  callCenterPhone = '0800 0200 0200';
  callCenterPhoneFormatted = '080002000200';

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
  }

  constructor(
    private appInitService: AppInitService,
    private pageLoaderService: PageLoaderService,
    private studentService: StudentService,
    private navigationService: NavigationService,
    private activatedRoute: ActivatedRoute,
    public platform: Platform,
    public modalController: ModalController,
    private router: Router,
    private statsService: StatsService,
    private utils: UtilsService,
    private CPFSubscriptionsService: CPFSubscriptionsService
  ) {
    super({ cancel: false, subscription: null });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.secureId = this.activatedRoute.snapshot.paramMap.get('secureId');

    // const getBackNavigation = this.navigationService.checkUserNavigation();
    // if (!!getBackNavigation && !!getBackNavigation.url) {
    //   this.blocHeaderBackUrl = getBackNavigation.url;
    // } else {
    //   this.blocHeaderBackUrl = 'code';
    // }

    this.isCordova = this.platform.is('cordova');
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest

    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }

    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.pageLoaderService.setSteps(
          this.pageLoaderSteps.indexOf('initApp') + 1,
          this.pageLoaderSteps.length
        );
        if (!this.initPageDone) {
          this.initPage();
        }
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  async initPage() {
    const callCenterElement = document.getElementById('call-center-phone');
    this.callCenterPhone =
      !!callCenterElement && !!callCenterElement.innerHTML
        ? callCenterElement.innerHTML
        : '';
    this.callCenterPhoneFormatted =
      !!callCenterElement && !!callCenterElement.innerHTML
        ? callCenterElement.innerHTML.replaceAll(' ', '')
        : '';
    if (!!this.secureId) {
      await this.initActiveStep();
    } else {
      this.openLink('splash');
    }

    this.initPageDone = true;

    // PAGE LOAD EVENT
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);

    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
    }
  }

  async initActiveStep() {
    this.displayErrorRetry = false;
    this.eligibiliteCPFCurrentStep =
      await this.CPFSubscriptionsService.getCPFEligibilitySteps(this.secureId);
    // console.log('eligibiliteCPFCurrentStep',this.eligibiliteCPFCurrentStep);

    if (this.eligibiliteCPFCurrentStep?.error) {
      this.displayErrorSecureId = true;
      return;
    }

    if (
      typeof this.eligibiliteCPFCurrentStep === 'object' &&
      Object.keys(this.eligibiliteCPFCurrentStep).length === 0
    ) {
      if (this.retry < 2) {
        this.retry++;
        // console.log("Rety amount", this.retry);

        setTimeout(async () => {
          await this.initActiveStep();
        }, 2000);
        return;
      }

      this.retry = 0;
      this.displayErrorEmpty = true;
      return;
    }

    if (
      typeof this.eligibiliteCPFCurrentStep === 'object' &&
      Object.keys(this.eligibiliteCPFCurrentStep).length > 0
    ) {
      if (
        this.eligibiliteCPFCurrentStep.status !==
        this.eligibiliteCPFPreviousStepStatus
      ) {
        this.setActiveStep();
        return;
      }

      if (this.retry < 2) {
        this.retry++;
        // console.log("Number of retry", this.retry);

        setTimeout(async () => {
          await this.initActiveStep();
        }, 2000);
        return;
      }

      this.retry = 0;
      this.displayErrorRetry = true;
      this.setActiveStep();
    }
  }

  setActiveStep() {
    this.retry = 0;
    switch (true) {
      case this.eligibiliteCPFCurrentStep.status === 'typeform to complete':
        this.loadTypeformStep();
        break;
      case this.eligibiliteCPFCurrentStep.status === 'contract to sign':
        this.loadYousignStep();
        break;
      case this.eligibiliteCPFCurrentStep.status === 'not eligible':
        this.loadRecapStep(1);
        break;
      case this.eligibiliteCPFCurrentStep.status === 'validated':
        this.loadRecapStep(2);
        break;
      case this.eligibiliteCPFCurrentStep.status === 'accepted':
        this.loadRecapStep(3);
        break;
      case this.eligibiliteCPFCurrentStep.status === 'canceled':
        this.loadRecapStep(4);
        break;
    }
  }

  loadTypeformStep() {
    this.activeStep = 1;
    this.eligibiliteCPFPreviousStepStatus =
      this.eligibiliteCPFCurrentStep.status;
    const CPFSubId = this.eligibiliteCPFCurrentStep.cpf_sub_id;
    const typeformId = this.eligibiliteCPFCurrentStep.typeform_id;

    this.checkTypeformDivReady = setInterval(() => {
      const typeformElement = document.querySelector(
        '#typeform-eligibilite-cpf'
      );

      if (!!typeformElement) {
        const { refresh, unmount } = createWidget(typeformId, {
          container: document.querySelector('#typeform-eligibilite-cpf'),
          iframeProps: { width: '100%', height: '100%' },
          hidden: {
            cpf_sub_id: CPFSubId,
          },
          onSubmit: async () => {
            // console.log("Typeform submitted");
            setTimeout(async () => {
              await this.initActiveStep();
            }, 2000);
          },
          onEndingButtonClick: async () => {
            // console.log("Typeform end button clicked");
            // await this.initActiveStep();
          },
        });

        clearInterval(this.checkTypeformDivReady);
      }
    }, 200);
  }

  loadYousignStep() {
    this.activeStep = 2;
    this.eligibiliteCPFPreviousStepStatus =
      this.eligibiliteCPFCurrentStep.status;
    this.yousignSignatureLink =
      this.eligibiliteCPFCurrentStep.yousign_signature_link;
  }

  loadRecapStep(subStep) {
    this.activeStep = 3;
    this.recapSubStep = subStep;
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  async openLink(link, options: any = {}) {
    if (link === 'myTrainingAccount') {
    }
    if (link === 'yousignSignatureLink') {
      link = this.yousignSignatureLink;
      options = { ...options, forceOutLink: true };
    }
    const callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
